import { Center, CenterProps, Spinner } from '@chakra-ui/react'
import React from 'react'

const CenteredSpinner: React.FC<CenterProps> = ({ ...props }) => {
    return (
        <Center mt={24} {...props}>
            <Spinner />
        </Center>
    )
}

export default CenteredSpinner
